import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-restrictive-acknowledgement-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './restrictive-acknowledgement-dialog.component.html',
  styleUrl: './restrictive-acknowledgement-dialog.component.scss'
})
export class RestrictiveAcknowledgementDialogComponent {
  @Input() mode: 'agreement' | 'rules' = 'agreement';
  @Output() agreed = new EventEmitter<void>();
  @Output() disagreed = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  get title(): string {
    return this.mode === 'agreement' ? 'Acknowledgement' : 'Restriction Rules';
  }

  get subtitle(): string {
    return this.mode === 'agreement'
      ? 'Please review and confirm before continuing.'
      : 'Review the sharing boundaries for this fleet.';
  }

  get infoBannerText(): string {
    return this.mode === 'agreement'
      ? 'Please confirm these sharing restrictions before proceeding.'
      : 'These restrictions help keep shared fleet content contained.';
  }

  onAgree() {
    this.agreed.emit();
  }

  onDisagree() {
    this.disagreed.emit();
  }

  onClose() {
    this.closed.emit();
  }

  onOverlayClick(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('dialog-overlay')) {
      if (this.mode === 'rules') {
        this.closed.emit();
      } else {
        this.disagreed.emit();
      }
    }
  }
}
